import * as angular from 'angular';
import AuthDataServiceName, {AuthDataService} from "../auth/authData.service";

let requires = [AuthDataServiceName];

export interface StateData {
  authorizeAdmin: boolean;
  authorizePlantAdmin: boolean;
  authorizeAPSIOAdmin: boolean;
}

export interface StateRolesService {
  stateRoleRequirementsSatisfied(stateData: StateData): boolean;
  stateRoleRequirementsSatisfiedForStateName(stateName: string): boolean;
}

class StateRolesSvc implements StateRolesService {
  private $state: angular.ui.IStateService;
  private authDataService: AuthDataService;

  constructor($state: angular.ui.IStateService,
              authDataService: AuthDataService) {
    this.$state = $state;
    this.authDataService = authDataService;
  }

  stateRoleRequirementsSatisfied(stateData: StateData): boolean {
    if (!stateData) {
      return true;
    }

    let authorized = false;
    let noSecurity = true;
    if (stateData.authorizeAPSIOAdmin) {
      noSecurity = false;
      authorized = this.authDataService.isAPSIOAdmin();
    }

    if (stateData.authorizeAdmin) {
      noSecurity = false;
      authorized = this.authDataService.isAdmin() || authorized;
    }

    if (stateData.authorizePlantAdmin) {
      noSecurity = false;
      authorized = this.authDataService.isAnyPlantAdmin() || authorized;
    }

    return authorized || noSecurity;
  }

  stateRoleRequirementsSatisfiedForStateName(stateName: string): boolean {
    let state = this.$state.get(stateName) || {};
    return this.stateRoleRequirementsSatisfied(state.data);
  }

}

export default angular
  .module('aps.services.stateRoles', requires)
  .service('stateRolesService', StateRolesSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/stateRoles/stateRoles.service.ts